import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card-product zoom" }
const _hoisted_2 = { class: "img-area" }
const _hoisted_3 = {
  key: 0,
  class: "tag-set justify-content-end"
}
const _hoisted_4 = { class: "tag2" }
const _hoisted_5 = { class: "btn-set" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "text-area" }
const _hoisted_8 = { class: "title secondary-font" }
const _hoisted_9 = { class: "price secondary-font" }

import { inject, ref } from 'vue';
import { formatAmount } from '@/utils/formatters';
import { useMarketCartStore } from '@/stores/cart.store';
import { showAlert } from '@/utils/swal';
import router from '@/router';


export default /*@__PURE__*/_defineComponent({
  __name: 'MarketCardProduct',
  props: {
    produit: { type: Object, required: true },
    layout: { type: String, default: 'none' },
},
  setup(__props) {

// @ts-expect-error raison: lib externe mal typée
const BACKEND_URL = inject('BACKEND_URL');
const props = __props;
const cart = useMarketCartStore();
const loadingCart = ref(false);

async function addProductToCart() {
    if (loadingCart.value) { return; }

    loadingCart.value = true;
    try {
        if (props.produit.mode_paiement === 'comptant' || props.produit.mode_paiement === 'echelonne') {
            await cart.addToCart({
                id: props.produit.id,
                nom: props.produit.nom,
                image: props.produit.image,
                montant: props.produit.montant,
                type_promotion: props.produit.type_promotion,
                taux_promotion: props.produit.taux_promotion,
                valeur_promotion: props.produit.valeur_promotion,
                montant_apres_remises: props.produit.montant_apres_remises,
                mode_paiement: props.produit.mode_paiement,
                montant_echeance: 0,
                nb_echeance: 0,
                total_promotion: 0,
                sous_total: 0,
                total: 0,
                total_echeance: 0,
            });
        } else {
            router.push((props.layout == 'frontoffice' ? '/front/market/produits/' : '/market/produits/') + props.produit.id);
        }
    } catch(error: any) {
        await showAlert.error(typeof error === 'string' ? error : 'Une erreur est survenue. Veuillez réessayer.');
    } finally {
        loadingCart.value = false;
    }
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (props.produit.type_promotion == 'PERCENTAGE' && props.produit.taux_promotion)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, "-" + _toDisplayString(Math.round(props.produit.taux_promotion)) + "%", 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: _normalizeClass(["btn-ultra lg btn-panier", {'loading': loadingCart.value}]),
          onClick: addProductToCart
        }, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "btn-show" }, [
            _createElementVNode("img", {
              src: "/public/icons/icon-panier.svg",
              class: "btn-icon",
              alt: ""
            })
          ], -1),
          _createElementVNode("div", { class: "btn-loading" }, [
            _createElementVNode("div", { class: "loader-dots" })
          ], -1)
        ]))], 2)
      ]),
      _createVNode(_component_router_link, {
        to: (__props.layout == 'frontoffice' ? '/front/market/produits/' : '/market/produits/') + props.produit.id,
        style: {"height":"290px","display":"flex","justify-content":"center","align-items":"center","padding":"20px"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _unref(BACKEND_URL) + '/assets/market_produits/300/' + props.produit.image,
            class: "img",
            style: {"max-width":"80%","max-height":"100%"}
          }, null, 8, _hoisted_6)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createVNode(_component_router_link, {
      to: (__props.layout == 'frontoffice' ? '/front/market/produits/' : '/market/produits/') + props.produit.id
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h5", _hoisted_8, _toDisplayString(props.produit.nom), 1),
          _createElementVNode("h3", _hoisted_9, [
            _createTextVNode(_toDisplayString(_unref(formatAmount)(props.produit.montant_apres_remises)) + " ", 1),
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "secondary-font" }, "F", -1))
          ])
        ])
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}
}

})